var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpenseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35_4120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07161 1.55259L6.55754 1.46888L4.5013 1.13403C4.04705 1.06006 3.61883 1.36832 3.54486 1.82259L2.3394 9.22508L2.18872 10.1504",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3575 2.30212L10.4617 1.77047L8.67016 0.707162C8.27438 0.472266 7.76312 0.602672 7.52821 0.998462L3.70032 7.44806L1.78638 10.6729",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.945577 12.1961C0.648526 11.8446 0.692695 11.3188 1.04423 11.0217L12.5015 1.3402C12.853 1.04314 13.3788 1.08732 13.6758 1.43885L19.0545 7.80398C19.3515 8.15553 19.3074 8.6813 18.9558 8.97836L7.49857 18.6599C7.14704 18.9569 6.62125 18.9128 6.32419 18.5612L0.945577 12.1961Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0757 11.2731C11.7787 10.679 11.8671 9.62739 11.273 8.92431C10.6789 8.22124 9.62728 8.13291 8.92421 8.72701C8.22114 9.32112 8.1328 10.3727 8.72691 11.0758C9.32101 11.7788 10.3726 11.8672 11.0757 11.2731Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53115 14.5687L5.9327 13.922L5.73642 14.1036L5.58739 13.9425L5.78367 13.7609L5.59273 13.5546L5.39644 13.7362L5.24741 13.5751L5.4437 13.3935L4.86854 12.7719L5.13025 12.5298L5.94448 12.9301L6.24143 12.6553L5.66627 12.0338L5.86507 11.8498L6.44023 12.4714L6.63652 12.2897L6.78555 12.4508L6.58926 12.6324L6.78021 12.8388L6.97649 12.6572L7.12552 12.8182L6.92924 12.9998L7.52769 13.6466L7.26345 13.8911L6.42594 13.4656L6.12899 13.7403L6.72744 14.3871L6.53115 14.5687ZM5.97996 13.5793L6.21651 13.3604L5.95007 13.2239L5.78398 13.3776L5.97996 13.5793ZM7.00055 13.4757L7.01062 13.4664L6.73295 13.1815L6.62726 13.2793L7.00055 13.4757ZM5.63495 13.2165L5.74065 13.1187L5.34621 12.9045L5.33614 12.9138L5.63495 13.2165ZM6.41783 13.1741L6.58644 13.0181L6.39046 12.8164L6.15139 13.0376L6.41783 13.1741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7073 7.70729L12.6247 5.62473L14.7073 7.70729Z",
    fill: "#300F88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7701 8.01967L14.6552 7.13458C14.8565 6.9333 14.8565 6.60697 14.6552 6.40569C14.4539 6.20441 14.1276 6.20441 13.9263 6.40569L13.4057 6.92633C13.2044 7.12761 12.878 7.12761 12.6768 6.92633C12.4755 6.72505 12.4755 6.39871 12.6768 6.19743L13.5619 5.31234M14.7073 7.70729L12.6247 5.62473",
    stroke: "white",
    strokeWidth: 0.294519,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35_4120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenseIcon);
export default __webpack_public_path__ + "static/media/expenseIcon.591919e44fc982c1dafb2f2227795190.svg";
export { ForwardRef as ReactComponent };